import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

import { showSuccessSnackbar } from 'modules/snackbar';

import MbButton from 'components/atoms/MbButton';
import NewPopoverWrap from 'components/molecules/NewPopoverWrap';
import CheckboxGroup from 'components/molecules/CheckboxGroup';
import NewRadioGroup from 'components/molecules/NewRadioGroup';
import NewSelectBox from 'components/molecules/NewSelectBox';

const Style = makeStyles((theme) => ({
  popoverWrap: {
    fontSize: '0.875rem',
    '&.disabled': {
      backgroundColor: 'rgb(234,234,234 ,26%)',
      borderColor: 'rgb(0, 0, 0, 0.26)',
      color: 'rgba(0, 0, 0, 0.38)',
      '& > div': { color: 'rgba(0, 0, 0, 0.38)', backgroundColor: 'initial' },
      '& > .mb-division': { backgroundColor: 'rgb(0, 0, 0, 0.26)' },
    },
  },
  optionWrap: { padding: 10 },
  options: { '& > div': { minWidth: 150 } },
  buttonWrap: { display: 'flex', flexDirection: 'row-reverse', padding: 10 },
}));

const FilterCollection = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    children,
    type,
    name = '',
    value,
    labelKey = '',
    valueKey = '',
    list = [],
    params = {},
    label,
    popoverWidth,
    popoverMaxWidth,
    popoverHeight,
    callBack = (f) => f,
    openCallBack = (f) => f,
    useSubmit = true,
    submitTitle = '저장',
    error,
    className,
    open: propsOpen,
    useAlllSelectBtn = false,
    disabled = false,
    filtered: propsFiltered = false,
    selectLabel: propsSelectLabel = '',
  } = props;
  const initSelectedLabel = propsSelectLabel;
  const initFiltered = propsFiltered;

  const classes = Style();
  const [newParams, setNewParams] = useState(params);
  const initSelectedOption =
    type === 'checkbox' && !!params[name] ? params[name].split(',') : [];
  const [selectedOption, setSelectedOption] = useState(initSelectedOption);
  const [filtered, setFiltered] = useState(initFiltered);
  const [selectedLabel, setSelectedLabel] = useState(initSelectedLabel);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!!type) {
      getSelectedLabel(params, props);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!!type) {
      let newSelectedOption =
        type === 'checkbox' && !!params[name] ? params[name].split(',') : [];
      setSelectedOption(newSelectedOption);
    }
    if (list.length > 1) {
      getSelectedLabel(params, props);
    }
    // eslint-disable-next-line
  }, [value, initFiltered, list]);

  useEffect(() => {
    if (!!type) {
      if (disabled) setOpen(false);
    }
    // eslint-disable-next-line
  }, [disabled]);

  useEffect(() => {
    if (!!type) getSelectedLabel(params, props);
    // eslint-disable-next-line
  }, [selectedOption]);

  useEffect(() => {
    if (!!type) {
      let newSelectedOption =
        type === 'checkbox' && !!params[name] ? params[name].split(',') : [];
      if (!params[name]) {
        setSelectedOption(initSelectedOption);
        setSelectedLabel(initSelectedLabel);
        setFiltered(initFiltered);
      } else {
        if (type === 'checkbox') {
          setSelectedOption(newSelectedOption);
        }
      }
    }
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setNewParams(params);
    }
    // eslint-disable-next-line
  }, [params]);

  // console.log(name, selectedOption, filtered);

  useEffect(() => {
    if (propsOpen === false) {
      setOpen(false);
    }
    if (filtered !== propsFiltered) {
      setFiltered(propsFiltered);
    }
    if (selectedLabel !== propsSelectLabel) {
      setSelectedLabel(propsSelectLabel);
    } // eslint-disable-next-line
  }, [propsOpen, propsFiltered, propsSelectLabel]);

  /***
   * 자식 컴포넌트에 있는 params 값을 부모로 가져올떄 사용
   * @param newParams
   */
  const handleGetValue = (newParams, name) => {
    if (type === 'checkbox') {
      setNewParams(newParams);
    } else if (type === 'radio' || type === 'select') {
      callBack(newParams, name);
      setNewParams(newParams);
      getSelectedLabel(newParams, props);
      handleClose();
    } else if (type === 'select') {
      getSelectedLabel(newParams, props);
    }
    if (useSubmit) {
    } else {
      handleClose();
    }
  };

  const handleAllCheck = (newArray) => {
    setSelectedOption(newArray);
  };

  /**
   * 확인 혹은 저장버튼 클릭하였을 때 실행되는 함수
   *
   */
  const handleSubmit = () => {
    callBack(newParams, name);
    getSelectedLabel(newParams, props);
    handleClose();
  };

  const handleGetSelectOption = (selectOption) => {
    if (type === 'checkbox') {
      setSelectedOption([...selectOption]);
    }
  };

  const getFiltered = (newParams) => {
    let tempFilterState = initFiltered;
    if (typeof newParams !== 'undefined') {
      if (type === 'checkbox') {
        tempFilterState = selectedOption.length > 0;
      } else if (type === 'radio' || type === 'select') {
        tempFilterState = !!params[name];
      }
    }
    setFiltered(tempFilterState);
  };

  const getSelectedLabel = (newParams, props) => {
    let newLabel;
    let newLabelArray = [];
    for (let i = 0; i < list.length; i++) {
      if (type === 'checkbox') {
        for (let v = 0; v < selectedOption.length; v++) {
          if (String(list[i][valueKey]) === selectedOption[v]) {
            newLabelArray.push(list[i][labelKey]);
          }
        }
      } else if (type === 'radio' || type === 'select') {
        if (String(list[i][valueKey]) === String(newParams[props.name])) {
          newLabel = list[i][labelKey];
        }
      }
    }
    if (type === 'checkbox') {
      if (newLabelArray.length > 1) {
        newLabel =
          newLabelArray[0] + ' 외 ' + (newLabelArray.length - 1) + '개';
      } else {
        newLabel = newLabelArray[0];
      }
    }
    setSelectedLabel(newLabel);
    getFiltered(newParams);
  };

  /**
   * popover를 열어주는 state 관리
   * 팝오버를 사용하기위한 버튼을 클릭했을때는 닫히고 열리고 모두 가능해야하기때문에 toggle로 사용
   */
  const handleToggleOpen = () => {
    if (open && type === 'checkbox') {
      if (
        selectedOption.length !== 0 &&
        params[name] !== String(selectedOption)
      ) {
        handleClickSnackbar({
          message: t('확인 버튼을 눌러야 저장됩니다.'),
          option: { type: 'info' },
        });
      }
    }
    setOpen(!open);
    openCallBack(!open, 'openFlag');
  };

  /**
   * callback으로 popover를 닫아주는 state 관리
   */
  const handleClose = () => {
    setOpen(false);
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <NewPopoverWrap
        label={label}
        open={open}
        // getOnClose={getOnClose}
        selectedLabel={selectedLabel}
        filtered={filtered}
        error={error}
        onClick={!!disabled ? (f) => f : handleToggleOpen}
        popoverWidth={popoverWidth}
        popoverMaxWidth={popoverMaxWidth}
        popoverHeight={popoverHeight}
        className={clsx(classes.popoverWrap, !!disabled && 'disabled')}
        filterList={
          <div className={clsx(className)}>
            {type === 'checkbox' ? (
              <div className={classes.optionWrap}>
                <div className={classes.options}>
                  <CheckboxGroup
                    params={params}
                    optionList={list}
                    labelKey={labelKey}
                    valueKey={valueKey}
                    name={name}
                    callBack={callBack}
                    handleGetValue={handleGetValue}
                    getSelectValue={handleGetSelectOption}
                    useAlllSelectBtn={useAlllSelectBtn}
                    selectedOption={selectedOption}
                    controllOption={{ type: useSubmit ? 'all' : undefined }}
                    handleAllCheck={handleAllCheck}
                  />
                </div>
                <div className={classes.buttonWrap}>
                  <MbButton onClick={handleSubmit}>{submitTitle}</MbButton>
                </div>
              </div>
            ) : type === 'radio' ? (
              <NewRadioGroup
                params={params}
                labelKey={labelKey}
                valueKey={valueKey}
                // selectedValue={optionSelectedValue}
                optionList={list}
                handleGetValue={handleGetValue}
                name={name}
              />
            ) : (
              type === 'select' && (
                <NewSelectBox
                  label={label}
                  name={name}
                  list={list}
                  params={params}
                  labelKey={labelKey}
                  valueKey={valueKey}
                  handleGetValue={handleGetValue}
                />
              )
            )}
            {children}
          </div>
        }
      />
    </>
  );
};

export default FilterCollection;
